import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Stack } from '@mui/material';

const META: Record<
  string,
  { title: string; body: string; settingsHash: string; emoji: string }
> = {
  stripe: {
    title: 'Stripe',
    body: 'Command center: balance, estimated MRR, customers (with search), subscriptions, invoices, and charges — powered by the Stripe API. Add your secret key in API settings.',
    settingsHash: 'stripe',
    emoji: '💳',
  },
  xero: {
    title: 'Xero',
    body: 'Invoices and receivables. Add your OAuth app credentials, then connect your organisation.',
    settingsHash: 'xero',
    emoji: '📗',
  },
  duda: {
    title: 'Website (Duda)',
    body: 'Partner API: list all sites, drill into site detail, and open reporting analytics (activities & traffic). Dev server uses a CORS proxy; production needs a backend.',
    settingsHash: 'duda',
    emoji: '🌐',
  },
  'google-ads': {
    title: 'Google Ads',
    body: 'Campaigns and spend will appear here once a secure backend handles Google Ads API OAuth.',
    settingsHash: 'ads',
    emoji: '📣',
  },
};

const IntegrationLandingPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const key = slug || '';
  const m = META[key] || {
    title: 'Integration',
    body: 'Unknown integration.',
    settingsHash: '',
    emoji: '🔗',
  };

  return (
    <Box sx={{ maxWidth: 640 }}>
      <Typography variant="h4" fontWeight={800} gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <span aria-hidden>{m.emoji}</span> {m.title}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {m.body}
      </Typography>
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        <Button variant="contained" onClick={() => navigate(m.settingsHash ? `/settings#${m.settingsHash}` : '/settings')}>
          API Settings
        </Button>
        {key === 'stripe' && (
          <Button variant="contained" color="secondary" onClick={() => navigate('/stripe/overview')}>
            Stripe dashboard
          </Button>
        )}
        {key === 'xero' && (
          <Button variant="contained" color="secondary" onClick={() => navigate('/xero/invoices')}>
            Xero invoices
          </Button>
        )}
        {key === 'duda' && (
          <Button variant="contained" color="secondary" onClick={() => navigate('/duda')}>
            Duda dashboard
          </Button>
        )}
        <Button variant="outlined" onClick={() => navigate('/sales')}>
          View analytics
        </Button>
      </Stack>
    </Box>
  );
};

export default IntegrationLandingPage;
